import { actionTypes } from './index';

export const resetCallTimer = () => (dispatch) => dispatch({
  type: actionTypes.CALL_TIMER_RESET,
});

export const tickCallTimer = () => (dispatch) => dispatch({
  type: actionTypes.CALL_TIMER_TICK,
});

export const setCallStartTimestamp = () => (dispatch) => dispatch({
  type: actionTypes.CALL_TIMER_TIMESTAMP,
});



// WEBPACK FOOTER //
// ./actions/callTimer.js